BaseCollection  = require('base/collection')
BaseModel       = require('base/model')

class Model extends BaseModel
  urlRoot: -> "smartNumbers/#{@get('numberId')}/campaign"

class CampaignCollection extends BaseCollection
  model: Model

module.exports = CampaignCollection